import React, { useState, useEffect } from 'react';
import { useTranslation } from '../../../i18n';
import { X, Coins } from 'lucide-react';

export default function ModalCotisation({ open, onClose, onSave, members, isAdmin, currentUserId, devise }) {
  const { t } = useTranslation();
  const [form, setForm] = useState({ user_id: '', montant: '', mois: '', note: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      const now = new Date();
      const defaultMois = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
      setForm({ user_id: currentUserId || '', montant: '', mois: defaultMois, note: '' });
    }
  }, [open, currentUserId]);

  if (!open) return null;

  const set = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.montant || !form.mois) return;
    setSaving(true);
    try {
      const payload = {
        montant: Number(form.montant),
        mois: form.mois,
        note: form.note,
      };
      if (isAdmin && form.user_id && form.user_id !== currentUserId) {
        payload.user_id = form.user_id;
      }
      await onSave(payload);
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" style={{ maxWidth: 460, width: '95%' }} onClick={e => e.stopPropagation()}>

        <div className="modal-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Coins size={18} style={{ color: 'var(--gold)' }} />
            <h2 className="modal-title">{t.cagnotte.logCotisation}</h2>
          </div>
          <button className="modal-close" onClick={onClose} type="button"><X size={16} /></button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">

            {/* Member selector — only shown to admin */}
            {isAdmin && members && members.length > 0 && (
              <div className="form-group">
                <label className="form-label">Membre</label>
                <select id="cotisation-user" className="form-select" value={form.user_id} onChange={set('user_id')}>
                  <option value={currentUserId}>Moi-même</option>
                  {members.filter(m => m.id !== currentUserId).map(m => (
                    <option key={m.id} value={m.id}>{m.prenom} {m.nom} — {m.email}</option>
                  ))}
                </select>
              </div>
            )}

            <div className="form-group">
              <label className="form-label">{t.cagnotte.cotisationMois} <span className="required">*</span></label>
              <input id="cotisation-mois" type="month" className="form-control" value={form.mois} onChange={set('mois')} required />
            </div>

            <div className="form-group">
              <label className="form-label">{t.cagnotte.cotisationMontant} ({devise || 'FCFA'}) <span className="required">*</span></label>
              <input
                id="cotisation-montant"
                type="number"
                min="0"
                step="any"
                className="form-control"
                value={form.montant}
                onChange={set('montant')}
                required
                placeholder="Ex: 25000"
              />
            </div>

            <div className="form-group">
              <label className="form-label">{t.cagnotte.cotisationNote}</label>
              <input
                id="cotisation-note"
                className="form-control"
                value={form.note}
                onChange={set('note')}
                placeholder="Note optionnelle..."
              />
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-outline" onClick={onClose}>{t.common.cancel}</button>
            <button type="submit" className="btn btn-primary" disabled={saving || !form.montant || !form.mois}>
              {saving ? t.common.loading : t.common.save}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
